import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewTipoOperacion = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'tipo_operacion',
        name: 'Tipo Operacion',
        component: ViewTipoOperacion,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
